
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../Assets/images/logo.png'

function Header(props) {
    const location = useLocation()
    const path = location.pathname

    const openmenu = () => {
        const id = document.getElementById('hamburger-icn')
        id.classList.toggle('is-active')
    }

    const [token, set_token] = useState("");
    useEffect(() => {
        TokenStatus();
    }, [])

    const TokenStatus = () => {
        if (localStorage.getItem("PPKTOKEN")) set_token(localStorage.getItem("PPKTOKEN") ?? "");
    }

    return (
        <header className='sticky top-0 z-50'>
            <div className='container'>
                <div className='flex items-center h-16 gap-6'>
                    <div className='logod-div'>
                        <Link to={'/'}>
                            <img src={logo} alt='logo' className='w-32' />
                        </Link>
                    </div>
                    <div className='menu-wrapper ml-auto'>
                        <div className='main-menu'>
                            <ul className='px-4'>
                                <li>
                                    <Link to='/' className={path === '/' ? 'active' : ''}>
                                        Home
                                    </Link>
                                </li>
                                <li>
                                    <a href='/home#services'>
                                        Services
                                    </a>
                                </li>
                                <li>
                                    <a href='/donation-for-indian-army' className={path === '/donation-for-indian-army' ? 'active' : ''}>
                                        Donate For Indian Forces
                                    </a>
                                </li>
                                {token === "" && <li>
                                    <Link to='/founder' className={path === '/founder' ? 'active' : ''}>
                                        Founder
                                    </Link>
                                </li>}
                                {token === "" && <li>
                                    <Link to='/user' className={path === '/user' ? 'active' : ''}>
                                        User
                                    </Link>
                                </li>}
                                {token !== "" && <li>
                                    <Link to='/advertisements' className={path === '/advertisements' ? 'active' : ''}>
                                        Access Your Dashboard
                                    </Link>
                                </li>}
                                <li>
                                    <Link to='/contact-us' className={path === '/contact-us' || path === '/know-more' ? 'active' : ''}>
                                        Contact
                                    </Link>
                                </li>
                                <li>
                                    <Link to='/about-us' className={path === '/about-us' || path === '/know-more' ? 'active' : ''}>
                                        About Us
                                    </Link>
                                </li>
                            </ul>
                            <div className="hamburger tabletmin:hidden" id="hamburger-icn" onClick={(e) => openmenu(e)}>
                                <span className="line"></span>
                                <span className="line"></span>
                                <span className="line"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;